import React from 'react';
import { Container, Box, Typography, Link, Divider, List, ListItem, ListItemText } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';

const SectionHeading = ({ children }) => (
  <Typography variant="h5" component="h2" sx={{ mt: 6, mb: 2, fontWeight: 700 }}>
    {children}
  </Typography>
);

export default function SecurityStatementPage() {
  return (
    <>
      <LandingPageNav />
      <Container maxWidth="md" sx={{ pt: { xs: 10, md: 12 }, pb: { xs: 6, md: 8 } }}>
        <Box>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 3 }}>
            Security Statement
          </Typography>

          <SectionHeading>How Jet HomeLoans, LP Protects You</SectionHeading>
          <Typography variant="body1" sx={{ mb: 3 }}>
            We value you as a customer and make it a top priority to ensure your visit to our site is secure and helpful.
          </Typography>

          <Typography variant="body1" sx={{ mb: 2 }}>
            We protect your personal information online using the following security measures:
          </Typography>
          <List sx={{ mb: 3 }}>
            <ListItem disableGutters>
              <ListItemText primary="Anti-virus software detects viruses and prevents them from entering our computer networks." />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Firewalls block unauthorized access." />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText
                primary={
                  <>
                    Encryption technology, such as Secure Sockets Layer (SSL), ensures information remains confidential during transmission. Data is protected in two key ways:
                  </>
                }
              />
            </ListItem>
            <List sx={{ pl: 3 }}>
              <ListItem disableGutters>
                <ListItemText primary="Authentication ensures that we know that it is actually you we are communicating with, and prevents another person and or machine from impersonating you." />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText primary="Encryption converts data from its original form to a form that can only be read by someone who can reverse the encryption. This prevents unauthorized users from reading the data." />
              </ListItem>
            </List>
          </List>

          <Typography variant="body1" sx={{ mb: 2 }}>
            Our web sites collect limited information during your visit.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            We may place cookies and similar files on your hard drive for purposes such as security, site navigation, and personalizing your web site experience. Our cookies do not identify you by name or by account number.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Our site may also collect technical and navigational information, such as browser type, IP (internet protocol) address, and pages visited.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            This type of information may be used, for example, to alert you to software or browser compatibility issues, or to improve our web site’s functionality.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            For more information, please review our <Link href="/privacy" underline="hover">Privacy Policy</Link>.
          </Typography>

          <SectionHeading>Here are a few ways you can help manage security from your end.</SectionHeading>
          <SectionHeading>Protect Your Information</SectionHeading>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Phishing scammers lure their targets into a false sense of security by spoofing the familiar, trusted logos of legitimate companies.
          </Typography>
          <List sx={{ mb: 3 }}>
            <ListItem disableGutters>
              <ListItemText primary="Use caution when opening attachments or clicking links in emails." />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Hover over the email address or links to see the full web address." />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Look for generic greetings or information the sender should already have." />
            </ListItem>
          </List>

          <SectionHeading>Prevent Mortgage Scams</SectionHeading>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Fraudsters ask for your personal and financial information or for funds to be wired to proceed with your loan.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Contact the appropriate parties prior to taking any action.
          </Typography>

          <SectionHeading>Place A Call</SectionHeading>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Scammers use pressure tactics and prey on fear.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            If you think a company involved in your real estate transaction needs information from you, or something you received looks suspicious, call to verify the communication is truly from that company.
          </Typography>

          <SectionHeading>Cybersecurity</SectionHeading>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Jet HomeLoans recommends that all our customers familiarize themselves with the The Department of Homeland Security’s (DHS) “Stop.Think.Connect” campaign. DHS’s Stop.Think.Connect. Campaign is a national public awareness campaign aimed at increasing the understanding of cyber threats and empowering the American public to be safer and more secure online. Cybersecurity is a shared responsibility. We each have to do our part to keep the Internet safe. When we all take simple steps to be safer online, it makes using the Internet a more secure experience for everyone.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            For more information the DHS’s Stop.Think.Connect campaign, click <Link href="https://www.dhs.gov/stopthinkconnect" target="_blank" rel="noopener">Department of Homeland Security’s Stop.Think.Connect Campaign</Link>.
          </Typography>

          <Divider sx={{ my: 5 }} />
          <Typography variant="body2" color="text.secondary">
            Last Updated: June 24, 2022
          </Typography>
        </Box>
      </Container>
      <Footer />
    </>
  );
}